import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ThreadExtendedActivityTargetAudiencesAndNetworksLoadAction } from '../../domains/threadExtendedActivityTargetAudiencesAndNetworks/actions.types';

import { ThreadExtendedActivityTargetAudiencesAndNetworks } from './types';

export const initialState: ThreadExtendedActivityTargetAudiencesAndNetworks = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<
  ThreadExtendedActivityTargetAudiencesAndNetworks,
  ThreadExtendedActivityTargetAudiencesAndNetworksLoadAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD_EXTENDED_ACTIVITY_TARGET_AUDIENCES_AND_NETWORKS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.threadExtendedActivityTargetAudiencesAndNetworks);
    case 'THREAD_EXTENDED_ACTIVITY_TARGET_AUDIENCES_AND_NETWORKS.LOAD_PENDING':
      return moveToPending(state, [action.payload.threadId]);
    case 'THREAD_EXTENDED_ACTIVITY_TARGET_AUDIENCES_AND_NETWORKS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.threadId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
